"use strict";

require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RequestDetailsSideNavItem = exports.RequestDetailsSideNav = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
var _pageTitles = require("../../go/components/common/pageTitles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var mergeItem = function mergeItem(item, refItems) {
  var itemRef = _lodash.default.find(refItems, function (ref) {
    return ref.itemCode == item.itemCode;
  }) || {};
  var name = itemRef.name,
    costType = itemRef.costType;
  return _objectSpread(_objectSpread({}, item), {}, {
    name: name,
    costType: costType
  });
};
var RequestDetailsSideNav = function RequestDetailsSideNav(props) {
  var fundingStreams = props.fundingStreams,
    refItems = props.refItems,
    spot = props.spot,
    currentIndent = props.currentIndent,
    activityOrder = props.activityOrder;
  if (refItems === undefined) {
    return null;
  }
  var items = [];
  var knownActivities = _lodash.default.size(activityOrder);
  _lodash.default.forEach(fundingStreams, function (stream, index) {
    return _lodash.default.forEach(stream.children, function (activity, activityKey) {
      var mergedActivity = mergeItem(activity, refItems);
      var path = "".concat(index);
      var navIndex = _lodash.default.findIndex(activityOrder, function (act) {
        return mergedActivity.itemCode === act;
      });
      navIndex = navIndex > -1 ? navIndex : knownActivities++;
      items.push( /*#__PURE__*/_react.default.createElement(RequestDetailsSideNavItem, {
        key: "".concat(path, "-").concat(activityKey),
        refItems: refItems,
        spot: spot,
        currentIndent: currentIndent + 1,
        item: mergedActivity,
        sourcePath: path,
        itemKey: activityKey
      }));
    });
  });
  return _lodash.default.filter(items, function (item) {
    return item != null;
  });
};
exports.RequestDetailsSideNav = RequestDetailsSideNav;
var RequestDetailsSideNavItem = function RequestDetailsSideNavItem(props) {
  var item = props.item,
    refItems = props.refItems,
    spot = props.spot,
    currentIndent = props.currentIndent,
    sourcePath = props.sourcePath,
    itemKey = props.itemKey;
  var currPath = "".concat(sourcePath, "-children-").concat(itemKey); // matches pattern in ItemDispatch
  var name = _lodash.default.get(item, 'name');
  var projectName = _lodash.default.get(item, 'additionalInformation.projectName', false) ? " ".concat(_lodash.default.get(item, 'additionalInformation.projectName')) : '';
  var children = _lodash.default.cloneDeep(item.children);
  _lodash.default.forEach(children, function (child, childKey) {
    return _lodash.default.set(children, childKey, mergeItem(child, refItems));
  });
  var childrenItems = [];
  _lodash.default.forEach(children, function (child, childKey) {
    if (child.costType === null) {
      childrenItems.push( /*#__PURE__*/_react.default.createElement(RequestDetailsSideNavItem, {
        key: "".concat(currPath, "-").concat(childKey),
        refItems: refItems,
        spot: spot,
        currentIndent: currentIndent + 1,
        item: child,
        sourcePath: currPath,
        itemKey: childKey
      }));
    }
  });
  var classes = "item textSmall indent_".concat(currentIndent, " leftBar");
  var dataIdLink = "item-".concat(currPath);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: name
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Menu.Item, {
    name: name,
    onClick: function onClick() {
      document.title = "".concat(_pageTitles.HOME, " - ").concat(name);
    },
    key: name,
    as: "a",
    active: false,
    href: '#' + dataIdLink,
    className: classes,
    title: name
  }, name + projectName), childrenItems);
};
exports.RequestDetailsSideNavItem = RequestDetailsSideNavItem;
var _default = RequestDetailsSideNav;
exports.default = _default;